import React, { useState } from 'react';
import Modal from './Modal';
import './Modal.css';


export default function RoundOffersModal({ open, onClose, offers, setOffers, round, resetSignal, roundAmountsOrder = {} }) {
  const [localOffers, setLocalOffers] = useState(() => offers);
  // Track acceptedRound (accepted offer)
  const [acceptedRound, setAcceptedRound] = useState(null);

  // When modal opens at round end, reset localOffers
  React.useEffect(() => {
    setLocalOffers(offers);
  }, [offers, open, round]);

  // Reset acceptedRound when resetSignal changes
  React.useEffect(() => {
    setAcceptedRound(null);
  }, [resetSignal]);

  // When a row is clicked, set as accepted offer
  const handleRowClick = idx => {
    setAcceptedRound(idx);
  };

  const handleInput = (idx, field, value) => {
    setLocalOffers(prev => {
      const next = [...prev];
      if (!next[idx]) next[idx] = { round: idx + 1 };
      next[idx][field] = value;
      return next;
    });
  };

  const handleSave = (e) => {
    e.preventDefault();
    setOffers(localOffers);
    onClose();
  };

  // Highlight logic: only green for accepted offer
  const getRowClass = idx => {
    if (acceptedRound === idx) return 'bp-modal-row-green';
    return '';
  };

  return (
    <Modal open={open} onClose={onClose}>
      <button className="bp-modal-close" onClick={onClose}>&times;</button>
      <form onSubmit={handleSave}>
        <table className="bp-modal-table">
          <thead>
            <tr>
                <th>Runda</th>
                <th>Estimare</th>
                <th>Oferta băncii</th>
            </tr>
          </thead>
          <tbody>
            {[...Array(ROUND_BOXES.length)].map((_, idx) => (
              <tr
                key={idx}
                className={getRowClass(idx)}
              >
                <td
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleRowClick(idx)}
                >
                  {idx + 1}
                </td>
                <td>
                  {/* Estimate is calculated, so not editable */}
                  <span>{localOffers[idx]?.estimate || ''}</span>
                </td>
                <td>
                  <input
                    type="number"
                    inputMode="numeric"
                    value={localOffers[idx]?.offer || ''}
                    onChange={e => handleInput(idx, 'offer', e.target.value)}
                    enterKeyHint="done"
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.stopPropagation();
                        e.preventDefault();
                        const form = e.target.form;
                        if (form) form.requestSubmit();
                        e.target.blur(); // Remove focus to prevent moving to next field
                      }
                    }}
                    onKeyUp={e => {
                      if (e.key === 'Enter') {
                        e.stopPropagation();
                        e.preventDefault();
                        const form = e.target.form;
                        if (form) form.requestSubmit();
                        e.target.blur(); // Remove focus to prevent moving to next field
                      }
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ textAlign: 'right', marginTop: 12 }}>
          <button type="submit" className="bp-reset-btn">Salvează</button>
        </div>
      </form>
    </Modal>
  );
}

const ROUND_BOXES = [6, 4, 3, 3, 3, 2, 1, 1];